import { render, staticRenderFns } from "./Portfolio_preferences.vue?vue&type=template&id=24a7b31f&scoped=true&"
import script from "./Portfolio_preferences.vue?vue&type=script&lang=js&"
export * from "./Portfolio_preferences.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio_preferences.vue?vue&type=style&index=0&id=24a7b31f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a7b31f",
  null
  
)

export default component.exports